import { useIsPinCodeUser } from "~/hooks/useIsPinCodeUser/useIsPinCodeUser";

export const useContentVisibility = () => {
    const isPinCodeUser = useIsPinCodeUser();

    return ({
        showSettings: isPinCodeUser,
        showStudyInfo: isPinCodeUser,
        showGetHelp: isPinCodeUser
    });
};